export default {
    cn: {
      addRoleDialog: {
        roleNameError:'字母，数字，下划线，减号(4-16位)',
        not_empty: '不能为空',
        role_exists:'该角色已经存在',
        select_one_option: '请至少选择一项'
      }
    },
    hk: {
      addRoleDialog: {
        roleNameError:'字母，數字，下劃線，減號(4-16位)',
        not_empty: '不能為空',
        role_exists:'該角色已經存在',
        select_one_option: '請至少選擇一項'
      }
    },
    en: {
      addRoleDialog: {
        roleNameError:'Letters, numbers, underscores, minus signs (4-16 digits)',
        not_empty:'Can not be empty',
        role_exists:'The role already exists!',
        select_one_option: 'Please select at least one'
      }
    }
  }



// WEBPACK FOOTER //
// ./src/MultiLanguage/addRoleDialog.js